
	import Vue from "vue";
	import helpers from "../inc/helpers";
	import api from "../api";

	import LevyRow from "./LevyRow.vue";

	import TaxLevyYear from "../data/TaxLevyYear";
	import TaxLevy from "../data/TaxLevy";
	import TaxRate from "../data/TaxRate";
	import TaxLookup from "../data/TaxLookup";

	export default Vue.extend({
		props: {
			parcelId: String,
		},

		data() {
			return {
				isLoading: true,
				taxValues: null as null | TaxLookup,
				levyHistory: [] as Array<TaxLevyYear>,
				taxDistrict: null as null | TaxRate,
			};
		},

		mounted() {
			this.getParcelTaxValues(this.parcelId);
		},

		methods: {
			getParcelTaxValues(parcelId: string): Promise<boolean> {
				return new Promise((resolve, reject) => {
					api.getParcelTaxData(parcelId).then((taxLookup: TaxLookup) => {
						this.taxValues = taxLookup;

						let marketValue = taxLookup.MktValue;
						let taxDistrictStr = taxLookup.TaxDistrict;
						let taxDistrictCode = parseInt(taxDistrictStr.substring(0, 2));

						api.getTaxRate(taxDistrictCode).then((taxRate: TaxRate) => {
							this.taxDistrict = taxRate;
						});

						api.getParcelTaxFacts(parcelId).then((data) => {
							if (!!data) {
								for (const property in data) {
									let newTaxLevyYear = {} as TaxLevyYear;

									newTaxLevyYear.date = property;
									newTaxLevyYear.levys = [] as Array<TaxLevy>;

									data[property].forEach((levy: TaxLevy) => {
										let newLevy = levy as TaxLevy;
										newTaxLevyYear.levys.push(levy);
									});

									this.levyHistory.push(newTaxLevyYear);
								}
							}

							this.isLoading = false;
						});
					});
				});
			},
		},

		computed: {
			latestLevyYear(): null | TaxLevyYear {
				return !!this.levyHistory[0] ? this.levyHistory[0] : null;
			},

			sortedLevys(): Array<TaxLevy> {
				//return this.latestLevyYear.levys.sort((a, b) => a.NewM - b.NewM);
				return !!this.latestLevyYear ? this.latestLevyYear.levys : [];
			},
		},

		filters: {
			formatCurrency(val: string): string {
				return helpers.formatCurrency(val);
			},

			formatTaxDistrictNumber(number: number): string {
				return number.toString();
			},
		},

		watch: {
			parcelId() {
				this.getParcelTaxValues(this.parcelId);
			},
		},

		components: {
			LevyRow,
		},
	});
